// src/tips-v1-tip-tips.universal.ts
import { transformError as sdkTransformError } from "@wix/sdk-runtime/transform-error";
import { queryBuilder } from "@wix/sdk-runtime/query-builder";
import {
  renameKeysFromSDKRequestToRESTRequest,
  renameKeysFromRESTResponseToSDKResponse
} from "@wix/sdk-runtime/rename-all-nested-keys";

// src/tips-v1-tip-tips.http.ts
import { toURLSearchParams } from "@wix/sdk-runtime/rest-modules";
import { transformSDKTimestampToRESTTimestamp } from "@wix/sdk-runtime/transformations/timestamp";
import { transformRESTTimestampToSDKTimestamp } from "@wix/sdk-runtime/transformations/timestamp";
import { transformPaths } from "@wix/sdk-runtime/transformations/transform-paths";
import { resolveUrl } from "@wix/sdk-runtime/rest-modules";
function resolveWixTipsTipV1TipsServiceUrl(opts) {
  const domainToMappings = {
    "manage._base_domain_": [
      {
        srcPath: "/_api/tips-service",
        destPath: ""
      }
    ],
    _: [
      {
        srcPath: "/_api/tips-service",
        destPath: ""
      }
    ],
    "www.wixapis.com": [
      {
        srcPath: "/tips",
        destPath: ""
      }
    ]
  };
  return resolveUrl(Object.assign(opts, { domainToMappings }));
}
var PACKAGE_NAME = "@wix/auto_sdk_ecom_tips";
function previewTip(payload) {
  function __previewTip({ host }) {
    const metadata = {
      entityFqdn: "wix.tips.v1.tip",
      method: "POST",
      methodFqn: "wix.tips.tip.v1.TipsService.PreviewTip",
      packageName: PACKAGE_NAME,
      url: resolveWixTipsTipV1TipsServiceUrl({
        protoPath: "/v1/tips/preview",
        data: payload,
        host
      }),
      data: payload,
      transformResponse: (payload2) => transformPaths(payload2, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: "tip.distributions.createdDate" },
            { path: "tip.distributions.transaction.date" }
          ]
        }
      ])
    };
    return metadata;
  }
  return __previewTip;
}
function getTipByOrderId(payload) {
  function __getTipByOrderId({ host }) {
    const metadata = {
      entityFqdn: "wix.tips.v1.tip",
      method: "GET",
      methodFqn: "wix.tips.tip.v1.TipsService.GetTipByOrderId",
      packageName: PACKAGE_NAME,
      url: resolveWixTipsTipV1TipsServiceUrl({
        protoPath: "/v1/tips/order/{orderId}",
        data: payload,
        host
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload2) => transformPaths(payload2, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: "tip.distributions.createdDate" },
            { path: "tip.distributions.transaction.date" }
          ]
        }
      ])
    };
    return metadata;
  }
  return __getTipByOrderId;
}
function getTipByDraftOrderId(payload) {
  function __getTipByDraftOrderId({ host }) {
    const metadata = {
      entityFqdn: "wix.tips.v1.tip",
      method: "GET",
      methodFqn: "wix.tips.tip.v1.TipsService.GetTipByDraftOrderId",
      packageName: PACKAGE_NAME,
      url: resolveWixTipsTipV1TipsServiceUrl({
        protoPath: "/v1/tips/draft-order/{draftOrderId}",
        data: payload,
        host
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload2) => transformPaths(payload2, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: "tip.distributions.createdDate" },
            { path: "tip.distributions.transaction.date" }
          ]
        }
      ])
    };
    return metadata;
  }
  return __getTipByDraftOrderId;
}
function getTipChoice(payload) {
  function __getTipChoice({ host }) {
    const metadata = {
      entityFqdn: "wix.tips.v1.tip",
      method: "GET",
      methodFqn: "wix.tips.tip.v1.TipsService.GetTipChoice",
      packageName: PACKAGE_NAME,
      url: resolveWixTipsTipV1TipsServiceUrl({
        protoPath: "/v1/tips/choice/{purchaseFlowId}",
        data: payload,
        host
      }),
      params: toURLSearchParams(payload)
    };
    return metadata;
  }
  return __getTipChoice;
}
function updateTipChoice(payload) {
  function __updateTipChoice({ host }) {
    const metadata = {
      entityFqdn: "wix.tips.v1.tip",
      method: "PATCH",
      methodFqn: "wix.tips.tip.v1.TipsService.UpdateTipChoice",
      packageName: PACKAGE_NAME,
      url: resolveWixTipsTipV1TipsServiceUrl({
        protoPath: "/v1/tips/choice",
        data: payload,
        host
      }),
      data: payload
    };
    return metadata;
  }
  return __updateTipChoice;
}
function setTipOnOrder(payload) {
  function __setTipOnOrder({ host }) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: "tip.distributions.createdDate" },
          { path: "tip.distributions.transaction.date" }
        ]
      }
    ]);
    const metadata = {
      entityFqdn: "wix.tips.v1.tip",
      method: "POST",
      methodFqn: "wix.tips.tip.v1.TipsService.SetTipOnOrder",
      packageName: PACKAGE_NAME,
      url: resolveWixTipsTipV1TipsServiceUrl({
        protoPath: "/v1/tips/set",
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: (payload2) => transformPaths(payload2, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: "tip.distributions.createdDate" },
            { path: "tip.distributions.transaction.date" }
          ]
        }
      ])
    };
    return metadata;
  }
  return __setTipOnOrder;
}
function removeTipFromOrder(payload) {
  function __removeTipFromOrder({ host }) {
    const metadata = {
      entityFqdn: "wix.tips.v1.tip",
      method: "POST",
      methodFqn: "wix.tips.tip.v1.TipsService.RemoveTipFromOrder",
      packageName: PACKAGE_NAME,
      url: resolveWixTipsTipV1TipsServiceUrl({
        protoPath: "/v1/tips/remove",
        data: payload,
        host
      }),
      data: payload
    };
    return metadata;
  }
  return __removeTipFromOrder;
}
function addTipDistributionsToOrder(payload) {
  function __addTipDistributionsToOrder({ host }) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: "tipDistributions.createdDate" },
          { path: "tipDistributions.transaction.date" }
        ]
      }
    ]);
    const metadata = {
      entityFqdn: "wix.tips.v1.tip",
      method: "POST",
      methodFqn: "wix.tips.tip.v1.TipsService.AddTipDistributionsToOrder",
      packageName: PACKAGE_NAME,
      url: resolveWixTipsTipV1TipsServiceUrl({
        protoPath: "/v1/tips/tip-distributions/add",
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: (payload2) => transformPaths(payload2, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: "tipDistributions.createdDate" },
            { path: "tipDistributions.transaction.date" }
          ]
        }
      ])
    };
    return metadata;
  }
  return __addTipDistributionsToOrder;
}
function queryTipDistributions(payload) {
  function __queryTipDistributions({ host }) {
    const metadata = {
      entityFqdn: "wix.tips.v1.tip",
      method: "POST",
      methodFqn: "wix.tips.tip.v1.TipsService.QueryTipDistributions",
      packageName: PACKAGE_NAME,
      url: resolveWixTipsTipV1TipsServiceUrl({
        protoPath: "/v1/tips/tip-distributions/query",
        data: payload,
        host
      }),
      data: payload,
      transformResponse: (payload2) => transformPaths(payload2, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: "tipDistributions.createdDate" },
            { path: "tipDistributions.transaction.date" }
          ]
        }
      ])
    };
    return metadata;
  }
  return __queryTipDistributions;
}
function sumTipDistributionAmounts(payload) {
  function __sumTipDistributionAmounts({ host }) {
    const metadata = {
      entityFqdn: "wix.tips.v1.tip",
      method: "POST",
      methodFqn: "wix.tips.tip.v1.TipsService.SumTipDistributionAmounts",
      packageName: PACKAGE_NAME,
      url: resolveWixTipsTipV1TipsServiceUrl({
        protoPath: "/v1/tips/tip-distributions/sum-amounts",
        data: payload,
        host
      }),
      data: payload
    };
    return metadata;
  }
  return __sumTipDistributionAmounts;
}

// src/tips-v1-tip-tips.universal.ts
import { transformPaths as transformPaths2 } from "@wix/sdk-runtime/transformations/transform-paths";
var IdentityType = /* @__PURE__ */ ((IdentityType2) => {
  IdentityType2["UNKNOWN"] = "UNKNOWN";
  IdentityType2["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
  IdentityType2["MEMBER"] = "MEMBER";
  IdentityType2["WIX_USER"] = "WIX_USER";
  IdentityType2["APP"] = "APP";
  return IdentityType2;
})(IdentityType || {});
var Source = /* @__PURE__ */ ((Source2) => {
  Source2["UNKNOWN_SOURCE"] = "UNKNOWN_SOURCE";
  Source2["POS"] = "POS";
  Source2["WEB"] = "WEB";
  Source2["DASHBOARD"] = "DASHBOARD";
  return Source2;
})(Source || {});
var TipType = /* @__PURE__ */ ((TipType2) => {
  TipType2["UNKNOWN_TIP_TYPE"] = "UNKNOWN_TIP_TYPE";
  TipType2["PERCENTAGE"] = "PERCENTAGE";
  TipType2["AMOUNT"] = "AMOUNT";
  TipType2["CUSTOM"] = "CUSTOM";
  return TipType2;
})(TipType || {});
var SortOrder = /* @__PURE__ */ ((SortOrder2) => {
  SortOrder2["ASC"] = "ASC";
  SortOrder2["DESC"] = "DESC";
  return SortOrder2;
})(SortOrder || {});
var QueryBy = /* @__PURE__ */ ((QueryBy2) => {
  QueryBy2["UNKNOWN_QUERY_BY"] = "UNKNOWN_QUERY_BY";
  QueryBy2["ORDER"] = "ORDER";
  QueryBy2["TIP"] = "TIP";
  return QueryBy2;
})(QueryBy || {});
var WebhookIdentityType = /* @__PURE__ */ ((WebhookIdentityType2) => {
  WebhookIdentityType2["UNKNOWN"] = "UNKNOWN";
  WebhookIdentityType2["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
  WebhookIdentityType2["MEMBER"] = "MEMBER";
  WebhookIdentityType2["WIX_USER"] = "WIX_USER";
  WebhookIdentityType2["APP"] = "APP";
  return WebhookIdentityType2;
})(WebhookIdentityType || {});
async function previewTip2(lineItemInfo, options) {
  const { httpClient, sideEffects } = arguments[2];
  const payload = renameKeysFromSDKRequestToRESTRequest({
    lineItemInfo,
    tipChoice: options?.tipChoice,
    tipSettingsId: options?.tipSettingsId
  });
  const reqOpts = previewTip(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(result.data);
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          lineItemInfo: "$[0]",
          tipChoice: "$[1].tipChoice",
          tipSettingsId: "$[1].tipSettingsId"
        },
        singleArgumentUnchanged: false
      },
      ["lineItemInfo", "options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function getTipByOrderId2(orderId) {
  const { httpClient, sideEffects } = arguments[1];
  const payload = renameKeysFromSDKRequestToRESTRequest({ orderId });
  const reqOpts = getTipByOrderId(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(result.data);
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: { orderId: "$[0]" },
        singleArgumentUnchanged: false
      },
      ["orderId"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function getTipByDraftOrderId2(draftOrderId) {
  const { httpClient, sideEffects } = arguments[1];
  const payload = renameKeysFromSDKRequestToRESTRequest({
    draftOrderId
  });
  const reqOpts = getTipByDraftOrderId(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(result.data);
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: { draftOrderId: "$[0]" },
        singleArgumentUnchanged: false
      },
      ["draftOrderId"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function getTipChoice2(purchaseFlowId) {
  const { httpClient, sideEffects } = arguments[1];
  const payload = renameKeysFromSDKRequestToRESTRequest({
    purchaseFlowId
  });
  const reqOpts = getTipChoice(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(result.data);
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: { purchaseFlowId: "$[0]" },
        singleArgumentUnchanged: false
      },
      ["purchaseFlowId"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function updateTipChoice2(tipChoice, options) {
  const { httpClient, sideEffects } = arguments[2];
  const payload = renameKeysFromSDKRequestToRESTRequest({
    tipChoice,
    purchaseFlowId: options?.purchaseFlowId
  });
  const reqOpts = updateTipChoice(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(result.data);
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          tipChoice: "$[0]",
          purchaseFlowId: "$[1].purchaseFlowId"
        },
        singleArgumentUnchanged: false
      },
      ["tipChoice", "options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function setTipOnOrder2(options) {
  const { httpClient, sideEffects } = arguments[1];
  const payload = renameKeysFromSDKRequestToRESTRequest({
    orderId: options?.orderId,
    tip: options?.tip
  });
  const reqOpts = setTipOnOrder(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(result.data);
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: { orderId: "$[0].orderId", tip: "$[0].tip" },
        singleArgumentUnchanged: false
      },
      ["options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function removeTipFromOrder2(options) {
  const { httpClient, sideEffects } = arguments[1];
  const payload = renameKeysFromSDKRequestToRESTRequest({
    orderId: options?.orderId
  });
  const reqOpts = removeTipFromOrder(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(result.data);
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: { orderId: "$[0].orderId" },
        singleArgumentUnchanged: false
      },
      ["options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function addTipDistributionsToOrder2(options) {
  const { httpClient, sideEffects } = arguments[1];
  const payload = renameKeysFromSDKRequestToRESTRequest({
    orderId: options?.orderId,
    tipDistributions: options?.tipDistributions
  });
  const reqOpts = addTipDistributionsToOrder(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(result.data);
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          orderId: "$[0].orderId",
          tipDistributions: "$[0].tipDistributions"
        },
        singleArgumentUnchanged: false
      },
      ["options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
function queryTipDistributions2() {
  const { httpClient, sideEffects } = arguments[0];
  return queryBuilder({
    func: async (payload) => {
      const reqOpts = queryTipDistributions(payload);
      sideEffects?.onSiteCall?.();
      try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return result;
      } catch (err) {
        sideEffects?.onError?.(err);
        throw err;
      }
    },
    requestTransformer: (query) => {
      const args = [query, {}];
      return renameKeysFromSDKRequestToRESTRequest({
        ...args?.[1],
        query: args?.[0]
      });
    },
    responseTransformer: ({
      data
    }) => {
      const transformedData = renameKeysFromRESTResponseToSDKResponse(
        transformPaths2(data, [])
      );
      return {
        items: transformedData?.tipDistributions,
        pagingMetadata: transformedData?.pagingMetadata
      };
    },
    errorTransformer: (err) => {
      const transformedError = sdkTransformError(err, {
        spreadPathsToArguments: {},
        explicitPathsToArguments: { query: "$[0]" },
        singleArgumentUnchanged: false
      });
      throw transformedError;
    },
    pagingMethod: "CURSOR",
    transformationPaths: {}
  });
}
async function sumTipDistributionAmounts2(filter) {
  const { httpClient, sideEffects } = arguments[1];
  const payload = renameKeysFromSDKRequestToRESTRequest({ filter });
  const reqOpts = sumTipDistributionAmounts(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(result.data);
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: { filter: "$[0]" },
        singleArgumentUnchanged: false
      },
      ["filter"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}

// src/tips-v1-tip-tips.public.ts
function previewTip3(httpClient) {
  return (lineItemInfo, options) => previewTip2(
    lineItemInfo,
    options,
    // @ts-ignore
    { httpClient }
  );
}
function getTipByOrderId3(httpClient) {
  return (orderId) => getTipByOrderId2(
    orderId,
    // @ts-ignore
    { httpClient }
  );
}
function getTipByDraftOrderId3(httpClient) {
  return (draftOrderId) => getTipByDraftOrderId2(
    draftOrderId,
    // @ts-ignore
    { httpClient }
  );
}
function getTipChoice3(httpClient) {
  return (purchaseFlowId) => getTipChoice2(
    purchaseFlowId,
    // @ts-ignore
    { httpClient }
  );
}
function updateTipChoice3(httpClient) {
  return (tipChoice, options) => updateTipChoice2(
    tipChoice,
    options,
    // @ts-ignore
    { httpClient }
  );
}
function setTipOnOrder3(httpClient) {
  return (options) => setTipOnOrder2(
    options,
    // @ts-ignore
    { httpClient }
  );
}
function removeTipFromOrder3(httpClient) {
  return (options) => removeTipFromOrder2(
    options,
    // @ts-ignore
    { httpClient }
  );
}
function addTipDistributionsToOrder3(httpClient) {
  return (options) => addTipDistributionsToOrder2(
    options,
    // @ts-ignore
    { httpClient }
  );
}
function queryTipDistributions3(httpClient) {
  return () => queryTipDistributions2(
    // @ts-ignore
    { httpClient }
  );
}
function sumTipDistributionAmounts3(httpClient) {
  return (filter) => sumTipDistributionAmounts2(
    filter,
    // @ts-ignore
    { httpClient }
  );
}

// src/tips-v1-tip-tips.context.ts
import { createRESTModule } from "@wix/sdk-runtime/rest-modules";
var previewTip4 = /* @__PURE__ */ createRESTModule(previewTip3);
var getTipByOrderId4 = /* @__PURE__ */ createRESTModule(getTipByOrderId3);
var getTipByDraftOrderId4 = /* @__PURE__ */ createRESTModule(getTipByDraftOrderId3);
var getTipChoice4 = /* @__PURE__ */ createRESTModule(getTipChoice3);
var updateTipChoice4 = /* @__PURE__ */ createRESTModule(updateTipChoice3);
var setTipOnOrder4 = /* @__PURE__ */ createRESTModule(setTipOnOrder3);
var removeTipFromOrder4 = /* @__PURE__ */ createRESTModule(removeTipFromOrder3);
var addTipDistributionsToOrder4 = /* @__PURE__ */ createRESTModule(addTipDistributionsToOrder3);
var queryTipDistributions4 = /* @__PURE__ */ createRESTModule(queryTipDistributions3);
var sumTipDistributionAmounts4 = /* @__PURE__ */ createRESTModule(sumTipDistributionAmounts3);
export {
  IdentityType,
  QueryBy,
  SortOrder,
  Source,
  TipType,
  WebhookIdentityType,
  addTipDistributionsToOrder4 as addTipDistributionsToOrder,
  getTipByDraftOrderId4 as getTipByDraftOrderId,
  getTipByOrderId4 as getTipByOrderId,
  getTipChoice4 as getTipChoice,
  previewTip4 as previewTip,
  queryTipDistributions4 as queryTipDistributions,
  removeTipFromOrder4 as removeTipFromOrder,
  setTipOnOrder4 as setTipOnOrder,
  sumTipDistributionAmounts4 as sumTipDistributionAmounts,
  updateTipChoice4 as updateTipChoice
};
//# sourceMappingURL=index.mjs.map